"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var CoachingPlan = /*#__PURE__*/function () {
  function CoachingPlan(client) {
    (0, _classCallCheck2["default"])(this, CoachingPlan);
    this.client = client;
    this.resourceUrl = '/session';
  }

  (0, _createClass2["default"])(CoachingPlan, [{
    key: "getSessionList",
    value: function getSessionList(clientId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/client/").concat(clientId), args);
    }
  }, {
    key: "getArchivedSessionList",
    value: function getArchivedSessionList(clientId) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.get("".concat(this.resourceUrl, "/client/").concat(clientId, "/archived-sessions"), args);
    }
  }, {
    key: "deleteSession",
    value: function deleteSession(sessionId, clientId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client["delete"]("".concat(this.resourceUrl, "/").concat(sessionId), args);
    }
  }, {
    key: "getClientSession",
    value: function getClientSession(sessionId, clientId) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(sessionId, "/client/").concat(clientId), args);
    }
  }, {
    key: "updateGrowthSession",
    value: function updateGrowthSession(clientId, sowId, data) {
      var _this$client;

      for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
        args[_key5 - 3] = arguments[_key5];
      }

      return (_this$client = this.client).put.apply(_this$client, ["".concat(this.resourceUrl, "/client/").concat(clientId, "/growth-plan/").concat(sowId, "/growth-session"), data].concat(args));
    }
  }]);
  return CoachingPlan;
}();

exports["default"] = CoachingPlan;